import React from 'react';
import { Building2, ArrowLeft } from 'lucide-react';

export default function AvisLegal() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
      <div className="max-w-4xl mx-auto p-4 md:p-8 py-12">
        {/* Header */}
        <div className="flex justify-between items-center mb-8">
          <a
            href="/"
            className="text-gray-600 hover:text-gray-900 flex items-center gap-2 font-medium"
          >
            <ArrowLeft className="w-4 h-4" />
            Tornar
          </a>
          <div className="flex items-center gap-2">
            <img src="/logo.png" alt="Fercamp" className="h-8 object-contain" />
          </div>
        </div>

        {/* Contingut */}
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
          <h1 className="text-4xl font-bold mb-2" style={{ color: '#97312b' }}>
            Avís Legal
          </h1>
          <p className="text-sm text-gray-500 mb-8">Última actualització: Octubre 2025</p>

          <div className="space-y-6 text-gray-700 leading-relaxed">
            {/* 1. IDENTIFICACIÓ */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">1. Identificació del titular</h2>
              <p>
                En compliment amb el deure d'informació recollit a la Llei 10/2007, del 10 de maig, de comerç electrònic del Principat d'Andorra, 
                es faciliten a continuació les següents dades:
              </p>
              <ul className="list-disc list-inside mt-3 space-y-2 ml-4">
                <li><strong>Titular:</strong> Fercamp Immobiliària</li>
                <li><strong>Adreça:</strong> Andorra</li>
                <li><strong>Correu electrònic:</strong> fercamp@andorra.ad</li>
                <li><strong>Telèfon:</strong> +376 738 721</li>
                <li><strong>Web:</strong> www.fercamp.com</li>
              </ul>
            </section>

            {/* 2. OBJECTE */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">2. Objecte</h2>
              <p>
                El present avís legal regula l'ús i utilització del lloc web <strong>fercamp.com</strong> i del simulador 
                d'hipoteques basat en el Decret 381/2025 del Govern d'Andorra, del qual és titular Fercamp Immobiliària.
              </p>
              <p className="mt-3">
                La navegació pel lloc web atribueix la condició d'usuari i implica l'acceptació plena i sense reserves de 
                totes i cadascuna de les disposicions incloses en aquest Avís Legal.
              </p>
            </section>

            {/* 3. CONDICIONS D'ÚS */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">3. Condicions d'ús del simulador</h2>
              <p className="font-semibold mb-2">3.1. Caràcter orientatiu</p>
              <p>
                El simulador d'hipoteques és una <strong>eina orientativa</strong> basada en el Decret 381/2025 del Govern d'Andorra. 
                Els càlculs proporcionats són aproximats i poden variar segons les condicions específiques de cada entitat bancària 
                i la situació personal de l'usuari.
              </p>
              
              <p className="font-semibold mt-4 mb-2">3.2. Sense garanties</p>
              <p>
                Fercamp no garanteix l'exactitud, completesa o actualització dels càlculs del simulador. Les condicions reals poden 
                diferir segons la política de cada banc, canvis normatius posteriors i l'avaluació individual de cada sol·licitant.
              </p>
              
              <p className="font-semibold mt-4 mb-2">3.3. No constitueix assessorament</p>
              <p>
                L'ús del simulador no substitueix l'assessorament financer professional ni constitueix cap oferta vinculant o 
                compromís per part de Fercamp o de qualsevol entitat bancària.
              </p>
              
              <p className="font-semibold mt-4 mb-2">3.4. Exclusió de responsabilitat</p>
              <p>
                Fercamp no es fa responsable de les decisions financeres preses en base als resultats del simulador ni de possibles 
                discrepàncies amb les condicions reals ofertes per les entitats bancàries o l'Institut Nacional de l'Habitatge.
              </p>
            </section>

            {/* 4. PROPIETAT INTEL·LECTUAL */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">4. Propietat intel·lectual i industrial</h2>
              <p>
                Tots els continguts del lloc web (textos, imatges, logotips, marques, disseny, programari i codi font) són propietat 
                de Fercamp o de tercers que han autoritzat el seu ús, i estan protegits per les lleis de propietat intel·lectual i industrial.
              </p>
              <p className="mt-3">
                Queda prohibida la reproducció, distribució, comunicació pública i transformació dels continguts sense autorització 
                expressa i per escrit de Fercamp.
              </p>
            </section>

            {/* 5. ENLLAÇOS */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">5. Enllaços a tercers</h2>
              <p>
                El lloc web pot contenir enllaços a webs de tercers (entitats bancàries, Institut Nacional de l'Habitatge, etc.). 
                Fercamp no es fa responsable del contingut, funcionament ni condicions d'aquestes pàgines externes.
              </p>
            </section>

            {/* 6. MODIFICACIONS */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">6. Modificacions</h2>
              <p>
                Fercamp es reserva el dret a modificar en qualsevol moment i sense previ avís la presentació, configuració i 
                continguts del lloc web, així com les condicions d'ús.
              </p>
            </section>

            {/* 7. LEGISLACIÓ */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">7. Legislació aplicable</h2>
              <p>
                Les presents condicions es regeixen per la legislació andorrana. Per a qualsevol controvèrsia derivada de l'ús 
                del lloc web, les parts se sotmeten als jutjats i tribunals del Principat d'Andorra.
              </p>
            </section>

            {/* CONTACTE */}
            <section className="mt-8 p-6 bg-blue-50 rounded-xl border-2 border-blue-200">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Contacte</h3>
              <p>
                Per a qualsevol consulta o aclariment sobre aquest avís legal, podeu contactar amb nosaltres a través de:
              </p>
              <ul className="list-none mt-3 space-y-2">
                <li>📧 <a href="mailto:fercamp@andorra.ad" className="font-semibold hover:underline" style={{ color: '#97312b' }}>fercamp@andorra.ad</a></li>
                <li>📞 <a href="tel:+376738721" className="font-semibold hover:underline" style={{ color: '#97312b' }}>+376 738 721</a></li>
              </ul>
            </section>
          </div>
        </div>

        {/* Footer mini */}
        <div className="text-center mt-8">
          <a
            href="/"
            className="text-sm text-gray-600 hover:text-gray-900 underline"
          >
            Tornar al simulador
          </a>
        </div>
      </div>
    </div>
  );
}